import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { useSelector } from "react-redux";
import { userSelector } from "slices/user/userSlice";
import { DestinationFreightSummary } from "app/data/freights/model";

export const useInhouseFreightByETA = (groupBy?: string, destinationTerminal?: string) => {
  const userState = useSelector(userSelector);

  const { isFetching, isLoading, data, error } =
    useQuery<DestinationFreightSummary[]>({
      queryKey: [QUERY_KEYS.INHOUSE_FREIGHT_BY_ETA, groupBy, userState.activeTerminal?.id, destinationTerminal],
      queryFn: async () => {
        const originTerminal = userState.activeTerminal?.id;
        let params = {};
        if (groupBy) {
          params = { groupBy };
        }
        if (originTerminal) {
          params = { ...params, originTerminal };
        }
        if (destinationTerminal) {
          params = { ...params, destinationTerminal };
        }

        const response = await apiQueryAdapter.query<DestinationFreightSummary[]>(`/freight-at-dock/summary`,
          "GET",
          { params }
        );

        return response.data;
      },
    })
  return { isFetching, isLoading, data, error };
}